import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from '@cargos/sprintpay-utils';
import { Subject } from 'rxjs';
import { SearchHistoryFormErrorJSON, SearchHistoryFormGroupType } from '../models/search-history-form';
import { formSearchHistoryErrors } from './utils/form-errors';

@Component({
    selector: 'app-search-history',
    templateUrl: './search-history.component.html',
    styleUrls: ['./search-history.component.scss'],
    standalone: false,
})
export class SearchHistoryComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    public searchForm: SearchHistoryFormGroupType;
    public formError: SearchHistoryFormErrorJSON;
    public formSubmitted = false;
    public submitCompleted = false;
    public isLoadingResults = false;

    @Input()
    set isLoading(isLoading: boolean) {
        this.isLoadingResults = isLoading;

        if (!isLoading && this.searchInput?.dirty && this.formSubmitted) {
            this.submitCompleted = true;
        }
    }

    @Output() eventOnSubmitSearch = new EventEmitter<string>();
    @Output() eventOnResetField = new EventEmitter<boolean>();

    get searchInput(): AbstractControl<string> | null {
        return this.searchForm?.get('search');
    }

    constructor(private fb: NonNullableFormBuilder) {}

    ngOnInit(): void {
        this.createForm();
        this.setFormError();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    createForm(): void {
        this.searchForm = this.fb.group({
            search: ['', [CustomValidators.preventHTMLContent(), Validators.maxLength(50)]],
        });
    }

    submit(): void {
        if (!this.isLoading && this.searchInput?.value.length && this.searchInput.value.length !== 0) {
            this.formSubmitted = true;
            this.eventOnSubmitSearch.emit(this.searchInput.value);
        }
    }

    setFormError(): void {
        this.formError = formSearchHistoryErrors;
    }

    cleanInput(): void {
        this.formSubmitted = false;
        this.submitCompleted = false;
        this.searchForm.reset();

        this.eventOnResetField.emit(true);
    }
}
